export const ROUTES = {
  EDIT_SITE: "/editsite",
  DASHBOARD: "/dashboard",
  LOGIN: "/login",
  LOGIN_SSO: "/loginsso",
  FORGOT_PASSWORD: "/forgotPassword",
  RESET_PASSWORD: "/resetPassword",
  USER_REGISTRATION: "/userRegistration",
  DEVICES: "/devices",
  COMPANION_DEVICE_INFO_PAGE: "/companionDeviceInfoPage",
  CAMERA_INFO_PAGE: "/cameraInfoPage",
  ROI: "/roi",
  ALERTS: "/alerts",
  CREATE_RULE_SUMMARY: "/createRuleSummary",
  USERGROUPS: "/usergroups",
  USER_DETAILS: "/userdetails",
  USERGROUPS_DETAILS: "/usergroupsdetails",
  LOCATION: "/location",
  EVENTS: "/events",
  EVENTS_INFO: "/eventsInfo",
  CVAPPS: "/cvapps",
  CREATE_CVAPPS: "/createCVApps",
  SETTINGS: "/settings",
  SITES: "/sites",
  SUPPORT: "/support",
  ADDSITE: "/addsite",
  EDITSITE: "/editsite",
  CAMERA_ONBOARDING: "/cameraOnboarding",
  STATISTICS: "/statistics",
  ROLES: "/roles",
  CREATE_ROLE: "/createRole",
  BULK_RULE: "/bulkRule",
  CREATE_ALERT: "/createAlert",
  RULE_MODAL: "/ruleModal",
  STAT_DATA_SOURCE: "/statDataSource",
  ALERT_DETAILS: "/alertDetails",
  LICENSES: "/licenses",
  LICENSE_DETAILS: "/licensedetails",
  MANUAL_CALIBRATION: "/manualcalibration",
  USERS: "/users",
  CVAPP_SUB: "/cvAppSub",
  CVAPPS_LICENSE_TYPE: "/cvAppsLicenseType",
  POLYGON: "/polygon",
  CAMPUS_DETAILS: "/campusDetails",
  EDIT_ROLE: "/editRole",
  USER_SETTINGS: "/UserSettings",
  ENROLLED_APPEARANCE: "/enrolledAppearance",
  CREATE_APPEARANCE: "/createAppearance",
  EDIT_APPEARANCE: "/editAppearance",
  APPEARANCE_DEPLOYMENTS: "/appearanceDeployments",
  SEARCH: "/search",
  SEARCH_RESULT: "searchResult",
  ASSISTANT: "/assistant"
};

export const SAFE_REDIRECT_ROUTES = [
  ROUTES.FORGOT_PASSWORD,
  ROUTES.RESET_PASSWORD,
  ROUTES.USER_REGISTRATION,
  ROUTES.DEVICES,
  ROUTES.COMPANION_DEVICE_INFO_PAGE,
  ROUTES.CAMERA_INFO_PAGE,
  ROUTES.ROI,
  ROUTES.ALERTS,
  ROUTES.CREATE_RULE_SUMMARY,
  ROUTES.USERGROUPS,
  ROUTES.USER_DETAILS,
  ROUTES.USERGROUPS_DETAILS,
  ROUTES.LOCATION,
  ROUTES.EVENTS,
  ROUTES.EVENTS_INFO,
  ROUTES.CVAPPS,
  ROUTES.CREATE_CVAPPS,
  ROUTES.SETTINGS,
  ROUTES.SITES,
  ROUTES.SUPPORT,
  ROUTES.ADDSITE,
  ROUTES.EDITSITE,
  ROUTES.CAMERA_ONBOARDING,
  ROUTES.STATISTICS,
  ROUTES.ROLES,
  ROUTES.CREATE_ROLE,
  ROUTES.BULK_RULE,
  ROUTES.CREATE_ALERT,
  ROUTES.RULE_MODAL,
  ROUTES.STAT_DATA_SOURCE,
  ROUTES.ALERT_DETAILS,
  ROUTES.LICENSES,
  ROUTES.LICENSE_DETAILS,
  ROUTES.MANUAL_CALIBRATION,
  ROUTES.USERS,
  ROUTES.CVAPP_SUB,
  ROUTES.CVAPPS_LICENSE_TYPE,
  ROUTES.POLYGON,
  ROUTES.CAMPUS_DETAILS,
  ROUTES.EDIT_ROLE,
  ROUTES.USER_SETTINGS,
  ROUTES.ENROLLED_APPEARANCE,
  ROUTES.CREATE_APPEARANCE,
  ROUTES.EDIT_APPEARANCE,
  ROUTES.APPEARANCE_DEPLOYMENTS,
  ROUTES.SEARCH,
  ROUTES.SEARCH_RESULT,
  ROUTES.ASSISTANT
];

export const QUERY_PARAMS = {
  CCD_ID: "ccdId"
};

export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const QUERY_SAFE_CHAR_REGEX = /^[a-zA-Z0-9_-]+$/; // Allows alphanumeric, hyphens, and underscores (to cover most key/value needs)
export const CREATE_APPEARANCE_REGEX = /^[a-zA-Z0-9 _-]{5,50}$/; // Allow alphanumeric, spaces, underscore, hyphen with length constraints (e.g., 5-50 chars)